import { isOdinKey, ODIN_KEY_PREFIX } from './customerKey';

/**
 * Find the Odin-MCP customer mapping for a picker customer key: a CIPP / Entra tenant id, or
 * an `odin:<Odin customer id>` key for a customer without a managed M365 tenant.
 *
 * Returns null when no key is given ("All Customers"), and a CIPP id never matches a customer
 * without `platformIds.cipp`. Without both guards `undefined === undefined` matched such a
 * customer, and its figures filled the all-customers dashboard.
 *
 * @param {Array<object>|undefined} customers - rows from Odin-MCP `list_customers`
 * @param {string|null|undefined} key - the selected tenant id
 * @returns {object|null}
 */
export function findCustomerByCipp(customers, key) {
  if (!key || !Array.isArray(customers)) return null;
  if (isOdinKey(key)) {
    const odinId = key.slice(ODIN_KEY_PREFIX.length);
    return customers.find((c) => c?.id && c.id === odinId) || null;
  }
  const wanted = key.toLowerCase();
  return customers.find((c) => c?.platformIds?.cipp && c.platformIds.cipp.toLowerCase() === wanted) || null;
}
